import { useLocation } from "react-router-dom";
import { Button } from "antd";
import { get, noop } from "lodash";

import { usePatientData } from "@utils/customHooks";
import { useRemindersContext } from "../useReminders";
import { CanEdit } from "@components/accessLevel";
import { AddReminderComponent, EditReminderComponent } from "@components/reminder/remindersList/reminder";
import { MEMBERS_DETAILS_SCREEN_TITLE } from "@utils/constants";
import { useCadenceContext } from "@components/drawerOutreaches/useCadence";

export function CalenderPopups({members, updateMembers, updateStatus} : any) {
  const { isReminderPopupVisible, currentScreen, setIsReminderPopupVisible, reminderToBeEdited, setReminderToBeEdited, editReminderHandler, addReminderHandler, deleteReminderHandler } = useRemindersContext();

  const { patientId, patientName } = usePatientData();
  const location = useLocation();

  const {
    calendarMonthView
  } = useCadenceContext()

  function handleClose() {
    if (reminderToBeEdited) {
      setReminderToBeEdited(null);
    }

    setIsReminderPopupVisible(false);
  }

  function handleAdd({ toBeAdded = {} }: any, loaderCallback: any) {
    const { from, to, titleVal, recurrence, patientId, patientName , reminderTitle } = toBeAdded;
    addReminderHandler({ reminderStartDate: from, reminderEndDate: to, description: titleVal, recurrence, patientId, patientName,reminderTitle ,loaderCallback , members, updateMembers, updateStatus});
  }

  function handleEdit(reminder: any, loaderCallback: any) {
    editReminderHandler(reminder?.reminder, loaderCallback , members, updateMembers, updateStatus);
  }

  function handleDelete(reminder: any) {
    deleteReminderHandler({reminder : get(reminder , 'toBeDeletedItem' , {}) , loaderCallback  : get(reminder ,'loaderCallback' ,noop) ,operationRange : get(reminder , 'operationRange'), members, updateMembers, updateStatus });
  }

  function getMember() {
    if(location.pathname === "/member-detail") {
      return {
        patientId,
        patientName,
      };
    } 
    return null;
  }

  return (
    <>
      {/* {isReminderPopupVisible && <div className="overlay-modal"></div>} */}
      <CanEdit>
        {/* {moment(selectDate).isSameOrAfter(moment().format("YYYY-MM-DD")) ? ( */}
        {
          calendarMonthView !== 'cadences' &&
        <div className="grid-floating-add-button">
          <Button type="primary" shape="circle" className="add-event" onClick={() => setIsReminderPopupVisible(true)}>
            <i className="icon icon-plus"></i>
          </Button>
        </div> 
      }
        {/* ) : null} */}
      </CanEdit>
      {isReminderPopupVisible && (
        <AddReminderComponent
          listOfReminders={[]}
          handleAdd={handleAdd}
          setAction={noop}
          member={
            getMember()
          }
          showSearch={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? false : true}
          allowClear={currentScreen === MEMBERS_DETAILS_SCREEN_TITLE ? false : true}
          reminderOrigin={"memlist_local"}
          closeForm={handleClose}
        />
      )}
      {get(reminderToBeEdited, "reminderId") && (
        <EditReminderComponent
          listOfReminders={[]}
          member={getMember()}
          reminderToBeEdited={reminderToBeEdited}
          setAction={noop}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          reminderOrigin={"memlist_local"}
          closeForm={handleClose}
        />
      )}
    </>
  );
}
